import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { request } from '../../../../utils/request'
import { StackApi } from '../../../../assets/types/apiTypes'
import { DefaultOptionType } from 'antd/es/select'

export const StackSelect = (props: any) => {
  const [list, setList] = useState<DefaultOptionType[]>([])

  useEffect(() => {
    const getList = async () => {
      const res = await request.get<undefined, StackApi[]>('/dc/portal/api/config/listStack')
      setList(res.map(v => ({label: v.name, value: v.name, key: v.name})))
    }
    getList()
  }, [])


  return <Select options={list} {...props} />
}